import { useState } from "react";

const FAQ = ({ faqs, icons, bgColor }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      toggleFAQ(index);
    }
  };

  return (
    <div className="faq-area">
      {faqs.map((faq, index) => (
        <div
          key={index}
          className={`faq-item ${openIndex === index ? "open" : ""}`}
          onClick={() => toggleFAQ(index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          role="button"
          tabIndex={0}
          aria-expanded={openIndex === index}
          style={{
            cursor: "pointer",
            userSelect: "none",
            backgroundColor: bgColor || "transparent",
          }}
        >
          <div className="d-flex">
            <div className="checkbox">
              {icons?.[index] && (
                <img src={icons[index]} alt="" className="icon-blue" />
              )}
            </div>
            <div className="faq-title">{faq.question}</div>
            <span className="icon"></span>
          </div>
          <div
            className="faq-content"
            style={{ display: openIndex === index ? "block" : "none" }}
          >
            {faq.answer}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FAQ;
